export default __webpack_public_path__ + "static/media/OmbImg.0c07c96f.png";